import {
    SALES_CLOSE_POS_TERMINAL,
    CASH_MANAGEMENT_MAKE_DEPOSITS,
    CASH_MANAGEMENT_MAKE_PAY_INS,
    CASH_MANAGEMENT_MAKE_PAY_OUTS,
    SALES_OPEN_POS_TERMINAL,
    SALES_DISCOUNT,
    SALES_ISSUE_REFUND,
    SALES_VOID_ITEM,
    SALES_VOID_SALES,
    SALES_SERVICE_CHARGE,
    SALES_TOP_UP_GIFT_CARD,
    SALES_TRANSFER_GIFT_CARD,
    SALES_QUICK_OUT_OF_STOCK,
    SALES_SELL_GIFT_CARD,
    SALES_VOID_PAYMENT,
} from 'constant/permissions'
import { isEmpty } from 'lodash-es'
import {
    CLEAR_SHORT_LIFE_PERMISSIONS,
    CLEAR_PERMISSION_TOKEN,
    REQUEST_OTHER_USER_PERMISSION_START,
    REQUEST_OTHER_USER_PERMISSION_SUCCESS,
    REQUEST_OTHER_USER_PERMISSION_FAILED,
    SET_NEXT_MODULE,
    TOGGLE_PIN_DIALOG,
} from 'store/actions/otherModuleAction.action'
import { IAction } from 'types/storeTypes'

export enum ENextModule {
    Discount = 1,
    ServiceCharge = 2,
    Void = 3,
    PayIn = 4,
    PayOut = 5,
    Deposit = 6,
    OpenTerminal = 7,
    CloseTerminal = 8,
    InactiveCashActivity = 9,
    IssueRefund = 10,
    TransferGiftCard = 11,
    TopupGiftCard = 12,
    QuickOutOfStock = 13,
    SellGiftCard = 14,
    OpenDrawer = 15,
    VoidPayment = 16,
}

export const ENextModulePermission: {
    [key in ENextModule]: number[] | undefined
} = {
    [ENextModule.Discount]: [SALES_DISCOUNT],
    [ENextModule.ServiceCharge]: [SALES_SERVICE_CHARGE],
    [ENextModule.Void]: [SALES_VOID_ITEM, SALES_VOID_SALES],
    [ENextModule.PayIn]: [CASH_MANAGEMENT_MAKE_PAY_INS],
    [ENextModule.PayOut]: [CASH_MANAGEMENT_MAKE_PAY_OUTS],
    [ENextModule.Deposit]: [CASH_MANAGEMENT_MAKE_DEPOSITS],
    [ENextModule.OpenTerminal]: [SALES_OPEN_POS_TERMINAL],
    [ENextModule.CloseTerminal]: [SALES_CLOSE_POS_TERMINAL],
    [ENextModule.InactiveCashActivity]: [
        CASH_MANAGEMENT_MAKE_PAY_INS,
        CASH_MANAGEMENT_MAKE_PAY_OUTS,
        CASH_MANAGEMENT_MAKE_DEPOSITS,
    ],
    [ENextModule.IssueRefund]: [SALES_ISSUE_REFUND],
    [ENextModule.TransferGiftCard]: [SALES_TRANSFER_GIFT_CARD],
    [ENextModule.TopupGiftCard]: [SALES_TOP_UP_GIFT_CARD],
    [ENextModule.QuickOutOfStock]: [SALES_QUICK_OUT_OF_STOCK],
    [ENextModule.SellGiftCard]: [SALES_SELL_GIFT_CARD],
    [ENextModule.OpenDrawer]: [
        CASH_MANAGEMENT_MAKE_DEPOSITS,
        CASH_MANAGEMENT_MAKE_PAY_OUTS,
        CASH_MANAGEMENT_MAKE_PAY_INS,
    ],
    [ENextModule.VoidPayment]: [SALES_VOID_PAYMENT],
}

interface IOtherModuleActionState {
    loading: boolean
    /**
     * - short-life permissions(aka. action ID)
     * - The short-life permissions should be cleared when the specific UI session end
     * - For example, when the user close "Discount" dialog, the user cannot reopen "Discount" dialog unless re-enter the PIN
     **/
    shortLifePermissions: number[]
    openPinDialog: boolean
    /**
     * - JWT encoded contains granted permission information.
     * - it contains list of (granted_permission, granted_by_user_id)
     * - it should last longer until the certain session that required permissions
     * - for example, in QS the permissionToken should last longer until the user
     *   - finished "Payment"
     *   - clicked "New" button
     *   - clicked "Save" button
     *   - voided whole order
     *   - loaded different order
     * - some actions, e.g., open terminal, the `permissionToken` can be cleared immediately after successed
     */
    permissionToken?: string
    nextModule?: ENextModule
}

const initialState: IOtherModuleActionState = {
    loading: false,
    openPinDialog: false,
    shortLifePermissions: [],
}

function otherModuleActionReducer(
    state: IOtherModuleActionState = initialState,
    action: IAction,
): IOtherModuleActionState {
    const { payload, type } = action
    switch (type) {
        case REQUEST_OTHER_USER_PERMISSION_START:
            return {
                ...state,
                loading: true,
            }
        case REQUEST_OTHER_USER_PERMISSION_SUCCESS:
            return {
                ...state,
                permissionToken: payload.permissionToken,
                shortLifePermissions: payload.aqquiredModuleActionIds,
                loading: false,
            }
        case REQUEST_OTHER_USER_PERMISSION_FAILED:
            return {
                ...state,
                loading: false,
            }
        case CLEAR_SHORT_LIFE_PERMISSIONS:
            if (isEmpty(state.shortLifePermissions)) return state
            return {
                ...state,
                shortLifePermissions: [],
            }
        case CLEAR_PERMISSION_TOKEN:
            if (state.permissionToken === undefined) return state
            return {
                ...state,
                permissionToken: undefined,
            }
        case TOGGLE_PIN_DIALOG:
            return {
                ...state,
                openPinDialog: payload,
            }
        case SET_NEXT_MODULE: {
            return {
                ...state,
                nextModule: payload.module,
            }
        }

        default:
            return state
    }
}

export default otherModuleActionReducer
